// Consent Mode v2 + Google Ads Conversions + Enhanced Conversions.
import { ADS, adsConfigured } from "../config";

const CONSENT_KEY = "ba_consent";

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

let gtagLoaded = false;

export function initGtag() {
  if (gtagLoaded || !adsConfigured()) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS.conversionId}`;
  document.head.appendChild(s);
  window.gtag = window.gtag || gtag;
  window.gtag("js", new Date());
  window.gtag("config", ADS.conversionId);
  gtagLoaded = true;
}

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY));
  } catch {
    return null;
  }
}

export function hasMarketingConsent() {
  const c = getConsent();
  return !!(c && c.marketing);
}

export function setConsent(granted) {
  const value = { marketing: granted, ts: new Date().toISOString() };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  } catch {}

  const state = granted ? "granted" : "denied";
  window.gtag = window.gtag || gtag;
  window.gtag("consent", "update", {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });

  if (granted) initGtag();
  return value;
}

async function sha256Hex(value) {
  const data = new TextEncoder().encode(value.trim().toLowerCase());
  const buf = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

// Enhanced Conversions for Leads: gehashte Telefon/E-Mail an gtag uebergeben
export async function setEnhancedConversionData({ email, phone }) {
  if (!hasMarketingConsent() || !adsConfigured()) return;
  const userData = {};
  try {
    if (email) userData.sha256_email_address = await sha256Hex(email);
    if (phone) {
      // E.164 ohne Leerzeichen
      const normalized = phone.replace(/[^\d+]/g, "");
      userData.sha256_phone_number = await sha256Hex(normalized);
    }
    window.gtag = window.gtag || gtag;
    window.gtag("set", "user_data", userData);
  } catch (e) {
    // still silently
  }
}

// Getrennte Conversion-Aktionen mit Wert (chat_lead / lead_formular / anruf / whatsapp)
export function fireConversion(actionKey) {
  if (!hasMarketingConsent() || !adsConfigured()) return;
  const conv = ADS.conversions[actionKey];
  if (!conv) return;
  window.gtag = window.gtag || gtag;
  window.gtag("event", "conversion", {
    send_to: `${ADS.conversionId}/${conv.label}`,
    value: conv.value,
    currency: "EUR",
  });
}
